import { ReactNode, type JSX } from "react";

export const ANIMATE_OUT_SPEED = 200;
export const DEBOUNCE_TIME_DEFAULT = 100;
export const DEBOUNCE_TIME_SCROLL = 2000;

export enum ToastPosition {
  TOP_LEFT = 'top-left'
}

export enum ToastType {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning'
}

export type ToastOptionsMessage = ReactNode | string | (() => JSX.Element);
